var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"govuk-button",attrs:{"type":"submit","role":"button"},on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }